import Markdown, { defaultUrlTransform } from "react-markdown";

const markdownLinkRegex = /\[[^\]]+\]\([^)]+\)/g;
const markdownAutolinkRegex = /<[^>\s]+@[^>\s]+>|<(?:https?:\/\/|mailto:|tel:)[^>\s]+>/gi;
const urlRegex = /(?:https?:\/\/|mailto:|tel:|www\.)[^\s<>()]+/gi;
const emailRegex = /(^|[^\w.+-])([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})(?![\w-])/gi;
const phoneRegex = /(^|[^\w/+])((?:\+\d{1,3}|0\d{1,3})(?:[\s.-]?\(?\d{2,4}\)?){2,})(?![\w/])/g;

const normalizePhoneHref = (phoneNumber) => phoneNumber.replace(/[\s().-]/g, "");

const contactUrlTransform = (value) =>
  /^tel:\+?[\d\s().-]+$/i.test(value) ? value : defaultUrlTransform(value);

const collectProtectedRanges = (content) => {
  const ranges = [];
  const collect = (regex) => {
    for (const match of content.matchAll(regex)) {
      ranges.push({ end: match.index + match[0].length, start: match.index });
    }
  };

  collect(markdownLinkRegex);
  collect(markdownAutolinkRegex);
  collect(urlRegex);

  return ranges.sort((a, b) => a.start - b.start);
};

const autolinkContactText = (content = "") => {
  if (!content) {
    return "";
  }

  const protectedRanges = collectProtectedRanges(content);
  const chunks = [];
  let position = 0;

  const linkContacts = (text) =>
    text
      .replace(emailRegex, (_match, prefix, email) => `${prefix}[${email}](mailto:${email})`)
      .replace(phoneRegex, (_match, prefix, phoneNumber) => {
        const normalizedPhoneNumber = normalizePhoneHref(phoneNumber);
        return `${prefix}[${phoneNumber}](tel:${normalizedPhoneNumber})`;
      });

  for (const range of protectedRanges) {
    if (range.start < position) {
      continue;
    }

    chunks.push(linkContacts(content.slice(position, range.start)));
    chunks.push(content.slice(range.start, range.end));
    position = range.end;
  }

  chunks.push(linkContacts(content.slice(position)));

  return chunks.join("");
};

const MarkdownDisplay = ({ data, sx, ...props }) => (
  <div
    {...props}
    className={`[&_h1]:text-5xl [&_h1]:font-bold [&_h1]:mt-6 [&_h1]:mb-2 [&_h3]:text-2xl [&_h3]:font-bold [&_h2]:text-4xl [&_h2]:font-bold [&_p]:mt-4 [&_p]:mb-4 [&_ul]:list-disc [&_ul]:ml-4 [&_img]:block [&_img]:max-w-full [&_img]:h-auto [&_img]:mx-auto [&_img]:my-6 [&_a]:underline [&_a]:text-primary [&_a]:hover:text-primary500 ${
      sx ? sx : ""
    } text-wrap overflow-wrap`}
  >
    <Markdown urlTransform={contactUrlTransform}>{autolinkContactText(data)}</Markdown>
  </div>
);

export default MarkdownDisplay;
